import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { useDialog } from 'components/Modals';
import { ProdutosContext } from 'contexts/ProdutosContext';
import Card from 'components/Card';
import Button from 'components/Button';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import TableContainer from 'components/TableContainer';
import styles from '../styles';
import moment from 'moment';

const Estrutura = ({
  drops,
  onSubmit,
  onDelete,
  produto = {},
  disableActions,
  onSubmitEstrutura,
}) => {
  const { openDialog } = useDialog();
  const rotina = 'Estrutura';

  const Modal = ({ item }) => {
    const defaultValues = {
      id: item?.id,
      produto_id: produto?.id,
      componente_id: item?.componente_id || null,
      operacao: item?.operacao || '',
      sequencia: item?.sequencia || '',
      quantidade: item?.quantidade || '',
      perda: item?.perda || '',
    };
    const { control, handleSubmit } = useForm({ defaultValues });
    const { postLoading } = useContext(ProdutosContext);

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            Informações Gerais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <VirtualDrop
            name="componente_id"
            control={control}
            label="Componente"
            options={drops?.Produto}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask name="operacao" control={control} label="Operação" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask name="sequencia" control={control} label="Sequência" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask name="quantidade" control={control} label="Quantidade" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask name="perda" control={control} label="% Perda" />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit((data) => onSubmit({ Estruturas: [data] }))}
            loading={postLoading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  const ImportModal = () => {
    const defaultValues = {
      destino_id: produto?.id,
      origem_id: null,
    };
    const { control, handleSubmit } = useForm({ defaultValues });
    const { postLoading } = useContext(ProdutosContext);

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            Informações Gerais
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <VirtualDrop
            name="origem_id"
            control={control}
            label="Produto de Origem"
            options={drops?.Produto?.filter((p) => p?.origem === 'FABRICADO')}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmitEstrutura)}
            loading={postLoading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Card title="Estrutura" style={styles?.card}>
      <Grid container spacing={2}>
        {!disableActions && (
          <Grid item xs={12} textAlign="center">
            <Button
              variant="outlined"
              color="primary"
              sx={styles?.button}
              onClick={() => openDialog(<Modal />, 'Adicionar Estrutura')}
            >
              Adicionar
            </Button>
            <Button
              variant="outlined"
              color="primary"
              sx={styles?.button}
              onClick={() => openDialog(<ImportModal />, 'Importar Estrutura')}
            >
              Importar
            </Button>
          </Grid>
        )}
        {!!produto?.Estruturas?.length && (
          <Grid item xs={12}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Sequência</TableCell>
                    <TableCell>Referência</TableCell>
                    <TableCell>Componente</TableCell>
                    <TableCell>Perda</TableCell>
                    <TableCell>Quantidade</TableCell>
                    <TableCell>Custo Unitário</TableCell>
                    <TableCell>Custo Total</TableCell>
                    <TableCell>Atualizado em</TableCell>
                    <TableCell align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {produto?.Estruturas?.map((item) => (
                    <TableRow key={item?.id?.toString()}>
                      <TableCell>{item?.sequencia}</TableCell>
                      <TableCell>{item?.referencia}</TableCell>
                      <TableCell>
                        {
                          item?.Produto?.ProdutoDescricaos?.find(
                            (f) =>
                              f?.tipo === 'COMPLETA' || f?.tipo === 'REDUZIDA'
                          )?.descricao
                        }
                      </TableCell>
                      <TableCell>{item?.perda && `${item?.perda}%`}</TableCell>
                      <TableCell>
                        {item?.quantidade} {item?.sigla || ''}
                      </TableCell>
                      <TableCell>
                        {item?.custo_unitario?.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 6,
                        })}
                      </TableCell>
                      <TableCell>
                        {item?.custo_total?.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 6,
                        })}
                      </TableCell>
                      <TableCell>
                        {Boolean(item?.atualizado) &&
                          moment(item?.atualizado).isValid() &&
                          moment(item?.atualizado).format(
                            'DD/MM/YYYY [às] HH:mm'
                          )}
                      </TableCell>

                      <TableCell align="center">
                        {!disableActions && (
                          <IconButton
                            size="small"
                            onClick={() =>
                              openDialog(
                                <Modal item={item} />,
                                'Editar Estrutura'
                              )
                            }
                          >
                            <Edit />
                          </IconButton>
                        )}
                        {!disableActions && (
                          <IconButton
                            size="small"
                            onClick={() => onDelete({ rotina, id: item?.id })}
                          >
                            <Delete />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default Estrutura;
